/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */

// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
type ArgumentsType<T extends (...args: any[]) => any> = T extends (...args: infer A) => any ? A : never;

/**
 * ## cortex:std:debounce
 * Runs a behavior that should only happen after a repeated action has completed.
 */

// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
export function debounce<T extends (...args: any) => any>(fn: T, interval: number): (...args: ArgumentsType<T>) => void {
	let timeout: ReturnType<typeof setTimeout>;

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	return function debouncer(...args: any[]): void {
		// @ts-ignore
		const functionCall = (): void => fn.apply(this, args);

		clearTimeout(timeout);
		timeout = setTimeout(functionCall, interval);
	};
}
